import { DurationFilterComponent } from '@/scopes/search/components/DurationFilterComponent'
import { durationFilterOptionsSelector, isLoadingSelector } from '@/scopes/search/quick-search/components/selectors'
import { useQuickSearchSelector } from '@/scopes/search/quick-search/infrastructure/store/useQuickSearchSelector'
import * as React from 'react'

export function DurationFilter({
  onConfirm,
}: {
  onConfirm: (selection: string[]) => void
}) {
  const durationOptions = useQuickSearchSelector(durationFilterOptionsSelector)
  const isLoading = useQuickSearchSelector(isLoadingSelector)
  return (
    <DurationFilterComponent
      id="travel-duration-filter"
      onConfirm={onConfirm}
      options={durationOptions.options}
      selectedOptions={durationOptions.selectedOptions}
      disabled={isLoading || durationOptions.options.length === 0}
      biggerBreakpoint
    />
  )
}
